import React from 'react';
import { getRoundPercentageWithSymbol } from '../../../../shared/utils/smartutils';

export default function (
  t,
  arrayData,
  editable,
  onchangeInput,
  course,
  getColorFrequency,
  getColorAverage,
  updateDisciplinesLackingOnBlur
) {
  const subjectCol = [];
  if (arrayData && arrayData.length) {
    arrayData[0].data.forEach((item, index) => {
      const array = [
        {
          subject: item.name,
          title: t('general.average'),
          field: `${item.name}-average`,
          render: (rowData) => {
            const { data } = rowData;
            return editable ? (
              <input
                value={data[index].average}
                type="number"
                min={0}
                className="input-field"
                onBlur={updateDisciplinesLackingOnBlur}
                onChange={({ target }) =>
                  onchangeInput(
                    'average',
                    rowData,
                    parseFloat(target.value || 0),
                    index
                  )
                }
              />
            ) : (
              <span
                className={`pill-cell ${
                  data[index] &&
                  data[index].average !== null &&
                  getColorAverage(data[index].average, course.mediaApproval)
                }`}
              >
                {data[index] ? data[index].average : null}
              </span>
            );
          },
        },
        {
          subject: item.name,
          title: t('general.lack'),
          field: `${item.name}-absences`,
          render: (rowData) => {
            const { data } = rowData;
            return editable ? (
              <input
                value={data[index] ? data[index].absences : null}
                type="number"
                min={0}
                className="input-field"
                onBlur={updateDisciplinesLackingOnBlur}
                onChange={({ target }) =>
                  onchangeInput(
                    'absences',
                    rowData,
                    parseInt(target.value || 0, 0),
                    index
                  )
                }
              />
            ) : (
              <span
                className={`${getColorFrequency(
                  data[index] ? data[index].frequency : null,
                  course.minFrequency
                )}`}
              >
                {data[index] ? data[index].absences : null}
              </span>
            );
          },
        },
        {
          subject: item.name,
          title: t('general.freq-symbol'),
          field: `${item.name}-frequency`,
          render: (rowData) => {
            const { data } = rowData;
            return editable ? (
              <input
                value={data[index] ? data[index].frequency : null}
                type="number"
                min={0}
                max={100}
                className="input-field"
                onBlur={updateDisciplinesLackingOnBlur}
                onChange={({ target }) => {
                  onchangeInput(
                    'frequency',
                    rowData,
                    target.value &&
                      Number(target.value) >= 0 &&
                      Number(target.value) <= 100
                      ? parseFloat(target.value)
                      : 0,
                    index
                  );
                }}
              />
            ) : (
              <span
                className={`${getColorFrequency(
                  data[index] ? data[index].frequency : null,
                  course.minFrequency
                )}`}
              >
                {data[index] && data[index].frequency && (
                  <>{getRoundPercentageWithSymbol(data[index].frequency)}</>
                )}
              </span>
            );
          },
        },
      ];
      subjectCol.push(...array);
    });
  }

  return [{ title: t('general.students'), field: 'name' }, ...subjectCol];
}
